import styled from 'styled-components/macro';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledImageContainer = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
`;

export const FullCountDownWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
